import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import VideoCatalog from '../components/VideoCatalog/VideoCatalog';

const AI = () => {
  const videos = useMemo(
    () => [
       {
      url: '/higher_res_o_kultek.mp4',
      title: 'KÜLTEK "THE UNEXPECTED"',
      slug: 'KULTEK',
      desc: 'MERCI ADVERTISING',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Merci Advertising'
    },
     {
      url: '/higher_res_o_bagovit.mp4',
      title: 'BAGOVIT "EMPEZÁ POR LO ESENCIAL"',
      slug: 'BAGOVIT',
      desc: 'BB AGENCIA',
      director: 'DIR.: DAMIÁN GARÓFALO',
      agencia: 'BB Agencia'
    },
    {
      url: '/higher_res_o_intoxicacion.mp4',
      title: 'UNIVERSAL ASSISTANCE "TE CUESTA $0"',
      slug: 'UA-TECUESTA0',
      desc: 'MERCI ADVERTISING',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Merci Advertising'
    },
       {
      url: '/higher_res_o_vid6.mp4',
      title: 'ATMA & "SECTA"',
      slug: 'ATMA',
      desc:'ANITA & VEGA',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Agencia 1'
    },
    {
      url: '/higher_res_o_amadita.mp4',
      title: 'AMADITA LABORATORIOS',
      desc:'DENTSU',
      director: 'DIR.: SEBA MEGA DÍAZ',
      agencia: 'Agencia 1'
    },
      {
      url: '/higher_res_o_toddler.mp4',
      title: 'TODDLER "CAMBIÁS"',
      slug:'TODDLER',
      desc:'TODDLER',
      director: 'DIR.: TOMÁS DE LAS HERAS', 
      agencia: 'Agencia 1'
    },
      {
      url: '/higher_res_o_zurich.mp4',
      title: 'ZURICH "HOGAR GAMER"',
      slug:'ZURICH',
      desc:'THE PICNIC',
      director: 'DIR.: HERNÁN CHURBA',
      agencia: 'Agencia 1'
    },
    ],
    []
  );

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <VideoCatalog videos={videos} />
    </Box>
  );
};

export default AI;
